(function() {
  'use strict';

  var section = document.querySelector('[data-product-section]');
  if (!section || section.dataset.cuentoReady === 'true') return;
  section.dataset.cuentoReady = 'true';

  var optionButtons = section.querySelectorAll('[data-option-value]');
  var variantIdInput = section.querySelector('[data-variant-id]');
  var addToCartBtn = section.querySelector('.cuento-product__add-btn');
  var priceEl = section.querySelector('[data-product-price]');
  var productDataEl = document.querySelector('[data-product-variants]');
  var variants = [];

  if (productDataEl) {
    try {
      variants = JSON.parse(productDataEl.textContent);
    } catch (error) {
      variants = [];
    }
  }

  function getSelectedOptions() {
    var selected = {};

    section.querySelectorAll('[data-option-value].is-active').forEach(function(button) {
      selected[button.dataset.optionName] = button.dataset.optionValue;
    });

    return selected;
  }

  function findVariant(selected) {
    return variants.find(function(variant) {
      return variant.options.every(function(value, index) {
        return selected[variant.option_names[index]] === value;
      });
    });
  }

  function formatMoney(cents) {
    var currency = window.Shopify && window.Shopify.currency
      ? window.Shopify.currency.active
      : 'USD';

    return (cents / 100).toLocaleString('en-US', {
      style: 'currency',
      currency: currency
    });
  }

  function updatePrice(variant) {
    if (!priceEl || variant.price == null) return;

    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      priceEl.innerHTML = '';

      var salePrice = document.createElement('span');
      salePrice.className = 'cuento-product__price--sale';
      salePrice.textContent = formatMoney(variant.price);

      var comparePrice = document.createElement('span');
      comparePrice.className = 'cuento-product__price--compare';
      comparePrice.textContent = formatMoney(variant.compare_at_price);

      priceEl.appendChild(salePrice);
      priceEl.appendChild(comparePrice);
    } else {
      priceEl.textContent = formatMoney(variant.price);
    }
  }

  function updateFeaturedMedia(variant) {
    if (!variant.featured_image_id) return;

    var media = section.querySelector('[data-image-id="' + variant.featured_image_id + '"]');
    if (!media) return;

    section.querySelectorAll('[data-product-media]').forEach(function(item) {
      item.classList.toggle('is-active', item === media);
    });

    if (window.matchMedia('(max-width: 749px)').matches) {
      media.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
    }
  }

  function refreshOptionAvailability() {
    var selected = getSelectedOptions();

    optionButtons.forEach(function(button) {
      var candidate = Object.assign({}, selected);
      candidate[button.dataset.optionName] = button.dataset.optionValue;

      var isAvailable = variants.some(function(variant) {
        if (!variant.available) return false;

        return variant.option_names.every(function(optionName, index) {
          return candidate[optionName] == null || candidate[optionName] === variant.options[index];
        });
      });

      button.classList.toggle('is-unavailable', !isAvailable);
      button.setAttribute('aria-disabled', isAvailable ? 'false' : 'true');
    });
  }

  function updateVariant() {
    var variant = findVariant(getSelectedOptions());

    if (!variant) {
      if (addToCartBtn) {
        addToCartBtn.disabled = true;
        addToCartBtn.textContent = 'Unavailable';
      }
      return;
    }

    if (variantIdInput) variantIdInput.value = variant.id;

    if (addToCartBtn) {
      addToCartBtn.disabled = !variant.available;
      addToCartBtn.textContent = variant.available ? 'Add to Bag' : 'Sold Out';
    }

    updatePrice(variant);
    updateFeaturedMedia(variant);
    refreshOptionAvailability();

    var url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url.toString());
  }

  optionButtons.forEach(function(button) {
    button.addEventListener('click', function() {
      if (button.getAttribute('aria-disabled') === 'true') return;

      var group = button.closest('[data-option-group]');
      if (!group) return;

      group.querySelectorAll('[data-option-value]').forEach(function(sibling) {
        sibling.classList.remove('is-active');
        sibling.setAttribute('aria-pressed', 'false');
      });

      button.classList.add('is-active');
      button.setAttribute('aria-pressed', 'true');

      var selectedLabel = group.querySelector('.cuento-product__option-selected');
      if (selectedLabel) selectedLabel.textContent = button.dataset.optionValue;

      updateVariant();
    });
  });

  refreshOptionAvailability();
  updateVariant();

  var sizeGuideModal = document.querySelector('[data-size-guide-modal]');
  var sizeGuideOpen = section.querySelector('[data-size-guide-open]');
  var lastFocusedElement = null;

  function openSizeGuide() {
    if (!sizeGuideModal) return;
    lastFocusedElement = document.activeElement;
    sizeGuideModal.hidden = false;
    document.body.classList.add('cuento-modal-open');

    var closeButton = sizeGuideModal.querySelector('.cuento-size-guide__close');
    if (closeButton) closeButton.focus();
  }

  function closeSizeGuide() {
    if (!sizeGuideModal) return;
    sizeGuideModal.hidden = true;
    document.body.classList.remove('cuento-modal-open');
    if (lastFocusedElement) lastFocusedElement.focus();
  }

  if (sizeGuideOpen) sizeGuideOpen.addEventListener('click', openSizeGuide);

  if (sizeGuideModal) {
    sizeGuideModal.querySelectorAll('[data-size-guide-close]').forEach(function(button) {
      button.addEventListener('click', closeSizeGuide);
    });

    document.addEventListener('keydown', function(event) {
      if (event.key === 'Escape' && !sizeGuideModal.hidden) closeSizeGuide();
    });
  }

  var wishlistButton = section.querySelector('[data-wishlist-button]');
  var wishlistStorageKey = 'cuento_wishlist';

  function readStoredList(key) {
    try {
      var value = JSON.parse(window.localStorage.getItem(key) || '[]');
      return Array.isArray(value) ? value : [];
    } catch (error) {
      return [];
    }
  }

  function writeStoredList(key, value) {
    try {
      window.localStorage.setItem(key, JSON.stringify(value));
    } catch (error) {
      return;
    }
  }

  function renderWishlistState() {
    if (!wishlistButton) return;

    var handle = wishlistButton.dataset.productHandle;
    var isActive = readStoredList(wishlistStorageKey).indexOf(handle) > -1;
    var icon = wishlistButton.querySelector('[data-wishlist-icon]');

    wishlistButton.classList.toggle('is-active', isActive);
    wishlistButton.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    wishlistButton.setAttribute('title', isActive ? 'Remove from favorites' : 'Add to favorites');
    if (icon) icon.textContent = isActive ? '♥' : '♡';
  }

  if (wishlistButton) {
    renderWishlistState();

    wishlistButton.addEventListener('click', function() {
      var handle = wishlistButton.dataset.productHandle;
      var stored = readStoredList(wishlistStorageKey);
      var index = stored.indexOf(handle);

      if (index > -1) stored.splice(index, 1);
      else stored.unshift(handle);

      writeStoredList(wishlistStorageKey, stored.slice(0, 50));
      renderWishlistState();
    });
  }

  var currentProductEl = document.querySelector('[data-current-product]');
  var recentlyViewedSection = section.querySelector('[data-recently-viewed]');
  var recentlyViewedGrid = section.querySelector('[data-recently-viewed-grid]');
  var recentlyViewedStorageKey = 'cuento_recently_viewed';

  function createRecentCard(product) {
    var card = document.createElement('a');
    card.className = 'cuento-product__recent-card';
    card.href = product.url || ('/products/' + product.handle);

    var media = document.createElement('div');
    media.className = 'cuento-product__recent-media';

    if (product.featured_image) {
      var image = document.createElement('img');
      image.src = product.featured_image;
      image.alt = product.title || '';
      image.loading = 'lazy';
      media.appendChild(image);
    }

    var info = document.createElement('div');
    info.className = 'cuento-product__recent-info';

    var title = document.createElement('p');
    title.className = 'cuento-product__recent-title';
    title.textContent = product.title || '';

    var price = document.createElement('p');
    price.className = 'cuento-product__recent-price';
    price.textContent = formatMoney(product.price || 0);

    info.appendChild(title);
    info.appendChild(price);
    card.appendChild(media);
    card.appendChild(info);
    return card;
  }

  async function renderRecentlyViewed() {
    if (!currentProductEl || !recentlyViewedSection || !recentlyViewedGrid) return;

    var currentProduct;
    try {
      currentProduct = JSON.parse(currentProductEl.textContent);
    } catch (error) {
      return;
    }

    var stored = readStoredList(recentlyViewedStorageKey);
    var previousHandles = stored.filter(function(handle) {
      return handle !== currentProduct.handle;
    });
    var limit = Number(recentlyViewedGrid.dataset.limit || 4);
    var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';

    if (previousHandles.length) {
      var products = await Promise.all(previousHandles.slice(0, limit).map(function(handle) {
        return fetch(root + 'products/' + encodeURIComponent(handle) + '.js')
          .then(function(response) {
            if (!response.ok) throw new Error('Product request failed');
            return response.json();
          })
          .catch(function() { return null; });
      }));

      products.filter(Boolean).forEach(function(product) {
        recentlyViewedGrid.appendChild(createRecentCard(product));
      });

      if (recentlyViewedGrid.children.length) recentlyViewedSection.hidden = false;
    }

    writeStoredList(
      recentlyViewedStorageKey,
      [currentProduct.handle].concat(previousHandles).slice(0, 12)
    );
  }

  renderRecentlyViewed();
})();
